import { render, staticRenderFns } from "./RelatorioAtendimentosColaborador.vue?vue&type=template&id=37bda262"
import script from "./RelatorioAtendimentosColaborador.vue?vue&type=script&lang=js"
export * from "./RelatorioAtendimentosColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports